import Alpine from 'alpinejs';

Alpine.data('gallery', (images) => ({
    images: null,
    currentIndex: 0,
    openModal: false,

    init() {
        this.images = JSON.parse(images);
    },

    get currentImage() {
        return this.images[this.currentIndex];
    },

    open(index) {
        this.currentIndex = index;
        this.openModal = true;
    },

    close() {
        this.openModal = false;
    },

    next() {
        this.currentIndex = (this.currentIndex + 1) % this.images.length;
    },

    prev() {
        this.currentIndex = (this.currentIndex - 1 + this.images.length) % this.images.length;
    },
}));
